import { BfPageStoreProvider, useStoreState } from '@tw/tw-runtime-react';
import React, { useMemo, useState } from 'react';
import { TwTpCartEmpty, TwTpOrderEdit, TwTpOrderInfo } from '@tw/tw-templates-rn';

import { ElementUtils } from '@tw/tw-platform-react';
import { GiftGiftShoppingStore } from '../../stores/gift-shopping/gift-gift-shopping-store';
import { ROUTE_NAMES } from '@/app/navigation/route-names';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { SaleDocOrderDTO } from '@tw/clvip-api-gen';
import { ScrollView } from 'react-native';
import { TwPage } from '@tw/tw-components-rn';
import { useFocusEffect } from '@react-navigation/native';
import { usePageStoreLifecycle } from '@tw/tw-runtime-react';

export const getStatusColor = (status: string) => {
  //ordered(已下单), waitShipping(待发货), shipped(已发货)]
  switch (status) {
    case 'shipped':
      // 已经发货
      return '#8FBD69';
    case 'waitShipping':
      // #待发货
      return '#F19D4F';
  }
};

export const GiftGiftShopping = (props) => {
  const [store] = useState(() => new GiftGiftShoppingStore());
  usePageStoreLifecycle(store, props.route.params);

  console.log('GiftGiftShopping', props.route.params);

  useFocusEffect(
    React.useCallback(() => {
      store.onLoad();
      return;
    }, [store])
  );

  const orderData: SaleDocOrderDTO = useStoreState(store, (state) => state.orderData);
  const curActivity = useStoreState(store, (state) => state.curActivity);
  const orderGoodsTreeData = useStoreState(store, (state) => state.orderGoodsTreeData);
  const isTestMode = useStoreState(store, (state) => state.isTestMode);

  const canResetOrder = useMemo(() => {
    if (isTestMode) {
      return false;
    }

    if (curActivity && orderData) {
      if (curActivity.choseDeadline && new Date().getTime() < curActivity.choseDeadline) {
        return true;
      }
    }
    return false;
  }, [curActivity, orderData, isTestMode]);

  console.log('GiftGiftShopping aaa', orderData, orderGoodsTreeData, canResetOrder);

  return (
    <BfPageStoreProvider store={store}>
      <TwPage
      // footer={
      //   <>
      //     {orderData?.id && canResetOrder && (
      //       <TwButton
      //         shape={'round'}
      //         size={'xs'}
      //         onPress={() => {
      //           store.testFinishedOrder();
      //         }}
      //       >
      //         TODO: 模拟截止后,出货单模式(测试用)
      //       </TwButton>
      //     )}
      //     <TwButton
      //       shape={'round'}
      //       size={'xs'}
      //       style={{
      //         marginTop: 10
      //       }}
      //       onPress={() => store.testDeleteOrder()}
      //     >
      //       TODO: 删除订单(测试用)
      //     </TwButton>
      //   </>
      // }
      >
        <ScrollView style={{ height: '100%' }}>
          {orderData?.id ? (
            // 没到截止时间就可以重新选择
            !canResetOrder ? (
              <TwTpOrderInfo
                address={{
                  icon: 'icon-add-print',
                  title: ElementUtils.getTextDirectly(orderData.address, 'coordinates'),
                  state: '下单时间',
                  name: orderData.linkman,
                  mobile: orderData.linkmanPhone,
                  createdTime: orderData.createTime
                }}
                orderData={orderGoodsTreeData?.map((item) => {
                  return {
                    storeName: item.supplierData.name,
                    orderStatus: item.status.name,
                    statusColor: getStatusColor(item.status.code),
                    trackingNumber: item.courierNumber ? item.courierNumber.split(',') : undefined,
                    commodity: item.children.map((goods) => {
                      return {
                        title: goods.goodsData.name,
                        // TODO: 缺少字段
                        subTitle: '', //goods.goodsData.desc,
                        price: goods.goodsData.price,
                        num: goods.goodsData.num,
                        imageUrl: goods.goodsData.showPicture?.url || '',
                        onPress: () => {
                          store.onGoodClick(goods.goodsData.goodsId.id);
                        }
                      };
                    })
                  };
                })}
              />
            ) : (
              <TwTpOrderEdit
                deadline={curActivity.choseDeadline}
                address={{
                  icon: 'icon-add-print',
                  title: ElementUtils.getTextDirectly(orderData.address, 'coordinates'),
                  state: orderData?.directingStatus?.name ?? '进行中',
                  name: orderData.linkman,
                  mobile: orderData.linkmanPhone,
                  createdTime: orderData.createTime
                }}
                orderData={orderData.goodsInfo.map((item) => {
                  return {
                    title: item.name,
                    // TODO: 缺少字段
                    subTitle: '',
                    price: item.price,
                    num: item.num,
                    imageUrl: item.showPicture.url,
                    onPress: () => {
                      store.onGoodClick(item.goodsId.id);
                    }
                  };
                })}
                reSelectButtonText="重新选择"
                onReSelectButtonPress={() => {
                  store.reSetOrder();
                }}
              />
            )
          ) : (
            <TwTpCartEmpty
              cartEmptyButtonText="去选购"
              onCartEmptyButtonPress={() => {
                props.navigation.navigate(ROUTE_NAMES.HomeIndex, { screen: ROUTE_NAMES.GiftGiftMall });
              }}
            />
          )}
        </ScrollView>
      </TwPage>
    </BfPageStoreProvider>
  );
};
